import { OnDestroy, OnInit, Directive } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

@Directive()
export abstract class PageLayoutBaseComponent implements OnInit, OnDestroy {
  environment = environment;
  private pageIndexSub!: Subscription;

  constructor(protected appService: AppService) {}

  ngOnInit(): void {
    this.pageIndexSub = this.appService.getPageIndex().subscribe({
      next: () => {
        this.scrollToPageContainer();
      },
      error: (err) => console.error('Page index error', err),
    });
  }

  ngOnDestroy(): void {
    if (this.pageIndexSub) {
      this.pageIndexSub.unsubscribe();
    }
  }

  private scrollToPageContainer(): void {
    const pageContainer = document.querySelector(
      '.page-content-container'
    ) as HTMLElement | null;
    if (pageContainer) {
      const scrollParent = this.getScrollParent(pageContainer);
      if (scrollParent) {
        setTimeout(() => {
          scrollParent.scrollTo({ top: 0, behavior: 'smooth' });
        }, 0);
      }
    }
  }

  private getScrollParent(element: HTMLElement): HTMLElement | null {
    let parent = element.parentElement;
    while (parent) {
      const style = getComputedStyle(parent);
      const overflowY = style.overflowY;
      const isScrollable = overflowY === 'auto' || overflowY === 'scroll';
      if (isScrollable && parent.scrollHeight > parent.clientHeight) {
        return parent;
      }
      parent = parent.parentElement;
    }
    return document.documentElement;
  }
}
